import React from 'react';
import './subscriptionsHeader.css';
import MonthNav from "../../MonthNav/MonthNav";
import { useDispatch, useSelector } from "react-redux";
import { getSubscriptionsSagaAction } from "../../../redux/sagaActions";
import { addSubscriptionFormAction } from "../../../redux/rootReducer";
import Search from "../../Search/Search";
import { ADD_SUBSCRIPTION_FORM_INITIAL } from "../../../redux/initialStateConstant";

const SubscriptionsHeader = () => {
    const dispatch = useDispatch();
    const subscriptions = useSelector(state => state.subscriptions);

    return (
        <>
            <div className="subscription__search">
                <Search/>
            </div>
            <MonthNav
                current={ subscriptions.month_year }
                prev={ () => dispatch(getSubscriptionsSagaAction({ date: subscriptions.prev_month })) }
                next={ () => dispatch(getSubscriptionsSagaAction({ date: subscriptions.next_month })) }
            />
            <div
                className="subscription__add button button--add"
                onClick={ () => {
                    dispatch(addSubscriptionFormAction({
                        ...ADD_SUBSCRIPTION_FORM_INITIAL,
                        open: true,
                        addition_date: new Date().toLocaleDateString('fr-CA')
                    }));
                } }
            >Добавить абонемент</div>
        </>
    );
};

export default SubscriptionsHeader;